import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Seo } from "@/components/Seo";
import type { Domain } from "@/lib/types";

export function DomainsOverviewPage() {
  const [domains, setDomains] = useState<Domain[]>([]);

  useEffect(() => {
    fetch("/api/domains").then((r) => r.json()).then(setDomains);
  }, []);

  return (
    <div className="container mx-auto px-6 py-16">
      <Seo
        title="What We Do"
        description="Loose Goose Systems works across three domains: Software Development, Device Design, and Medical Projects."
        path="/domains"
      />
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <h1 className="font-display text-4xl font-extrabold tracking-tight mb-3">What We Do</h1>
        <p className="text-lg text-muted-foreground">
          Loose Goose Systems works across three domains. Some projects live in one; others span all three.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3 max-w-5xl mx-auto">
        {domains.map((d) => (
          <Link key={d.slug} to={`/domains/${d.slug}`} className="group">
            <Card className="h-full transition-all duration-300 group-hover:-translate-y-1 group-hover:border-teal/60 group-hover:shadow-lg">
              <CardHeader>
                <div className="text-5xl mb-3">{d.icon || "🦆"}</div>
                <CardTitle className="font-display text-xl transition-colors group-hover:text-teal">
                  {d.name}
                </CardTitle>
                <CardDescription className="text-base">{d.tagline}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
      {domains.length === 0 && (
        <p className="text-center text-muted-foreground mt-8">Domains coming soon.</p>
      )}
    </div>
  );
}
